<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M683.4 974.1H357c-73.9 0-143.4-28.8-195.7-81.1-52.3-52.3-81.1-121.8-81.1-195.7V338.1c0-73.9 28.8-143.4 81.1-195.7C213.5 90.1 283 61.3 357 61.3h326.4c73.9 0 143.4 28.8 195.7 81.1 52.3 52.3 81.1 121.8 81.1 195.7v359.2c0 73.9-28.8 143.4-81.1 195.7-52.3 52.3-121.8 81.1-195.7 81.1zM357 114.8c-123.1 0-223.3 100.2-223.3 223.3v359.2c0 123.1 100.2 223.3 223.3 223.3h326.4c123.1 0 223.3-100.2 223.3-223.3V338.1c0-123.1-100.2-223.3-223.3-223.3H357z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M307 275.9c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5-28.5-12.8-28.5-28.5 12.7-28.5 28.5-28.5zm426.4 57h-300c-15.7 0-28.5-12.8-28.5-28.5s12.8-28.5 28.5-28.5h300c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5zM307 489.2c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5-28.5-12.8-28.5-28.5c0-15.8 12.7-28.5 28.5-28.5zm426.4 57h-300c-15.7 0-28.5-12.8-28.5-28.5s12.8-28.5 28.5-28.5h300c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5zM307 702.4c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5-28.5-12.8-28.5-28.5 12.7-28.5 28.5-28.5zm426.4 57h-300c-15.7 0-28.5-12.8-28.5-28.5s12.8-28.5 28.5-28.5h300c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5z" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
